export type WorkPageTab = 'description' | 'chapters' | 'reviews';

export type WorkPageDeepLink = {
  activeTab: WorkPageTab;
  focusReviewComposer: boolean;
  highlightReviewId: number | null;
};

export type WorkPageSearchParams = {
  [key: string]: string | string[] | undefined;
};

const WORK_PAGE_TABS: readonly WorkPageTab[] = ['description', 'chapters', 'reviews'];

const readSearchParam = (
  searchParams: WorkPageSearchParams | undefined,
  key: string,
): string | null => {
  const value = searchParams?.[key];
  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value) && typeof value[0] === 'string') {
    return value[0];
  }

  return null;
};

const resolveWorkPageTab = (tabParam: string | null): WorkPageTab => {
  if (tabParam && WORK_PAGE_TABS.includes(tabParam as WorkPageTab)) {
    return tabParam as WorkPageTab;
  }

  return 'description';
};

/**
 * Maps work-page URL query into initial UI state (no client effect needed).
 */
export const resolveWorkPageDeepLink = (searchParams?: WorkPageSearchParams): WorkPageDeepLink => {
  const activeTab = resolveWorkPageTab(readSearchParam(searchParams, 'tab'));
  const reviewEntry = readSearchParam(searchParams, 'reviewEntry');
  const reviewId = Number(readSearchParam(searchParams, 'reviewId'));
  const isReviewsTab = activeTab === 'reviews';

  return {
    activeTab,
    focusReviewComposer: isReviewsTab && reviewEntry === 'compose',
    highlightReviewId: isReviewsTab && Number.isInteger(reviewId) && reviewId > 0 ? reviewId : null,
  };
};
